import { User } from "@/types/user";
import { createContext } from "react";

export const initialAnalyticsContext = {
    experimentationInitialized: false,
    trackEvent: (
        _eventName: string,
        _eventProperties?: Record<string, string | number | boolean | object>,
    ) => {},
    trackEventAttachedToClient: (
        _currentUser: User,
        _clientId: number,
        _eventName: string,
        _eventProperties?: Record<string, string | number | boolean | object>,
    ) => {},
    getExperimentVariant: (
        _experimentName: string,
        _fallback?: string,
        _triggerExposure?: boolean,
    ): string | undefined => undefined,
    triggerExposure: (_experimentName: string): void => {},
    triggerExposureOnBackend: (_experimentName: string): Promise<void> =>
        Promise.resolve(),
    setIsAmplitudeInitializationBlocked: (
        _isAmplitudeInitializationBlocked: boolean,
    ) => {},
};

export type AnalyticsContextType = typeof initialAnalyticsContext;

export const AnalyticsContext = createContext(initialAnalyticsContext);
